import React from 'react';
import PropTypes from 'prop-types';

import Link, { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import DefaultPicture, { propTypes as picturePropTypes } from '../../../01_atoms/DefaultPicture';
import ItemWithImage from '../../../02_molecules/Item/ItemWithImage';
import { formattedDate } from '../../../../utils/date-formatter.js';
import FormattedText from '../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

/**
 * Content dates only appear on mobile.
 */
const BBPublications = ({
  title,
  description,
  publications,
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb bb-publications ${
      styles['bb-publications']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      <div className={styles.wrapper}>
        <div className="row">
          <div className="col-12 col-lg-4">
            <h3>{title}</h3>
            <FormattedText className="text" text={description} />
          </div>
          {publications.map((publication) => (
            <div key={publication.title} className="col-12 col-lg-4">
              <div className="d-none d-md-block">
                <ItemWithImage
                  title={publication.title}
                  image={publication.image}
                  nextLink={publication.nextLink}
                />
              </div>
              <div className="d-md-none">
                <Link {...publication.nextLink}>
                  <a className="link-wrapper">
                    <div className="media">
                      {publication.image && (
                        <DefaultPicture loading="lazy" {...publication.image} />
                      )}

                      <div className="media-body">
                        <mark className="date">{formattedDate(publication.timestamp)}</mark>
                        <mark className="d-md-none title">
                          <strong>{publication.title}</strong>
                        </mark>
                      </div>
                    </div>
                  </a>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

BBPublications.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  publications: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      timestamp: PropTypes.number,
      image: PropTypes.shape(picturePropTypes),
      nextLink: PropTypes.shape(linkPropTypes),
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBPublications;
